export const getColumns = DATASETS_PAGE_ENABLED => [
  { label: 'Modified', type: 'date', width: '15%', lookup: 'updated_at' },
  { label: 'Name', width: '20%', lookup: 'identifier' },
  { label: DATASETS_PAGE_ENABLED ? 'Dataset' : 'Template', width: '25%', lookup: 'template_name' },
  { label: 'Rows', width: '10%', lookup: 'number_of_rows' },
  { label: 'Status', width: '20%', lookup: 'type' },
  { label: 'Actions', lookup: 'draft' },
]
